import { Record } from "immutable";

import createFromJS from "../../../createFromJS";
import { DateRecord } from "./DateRecord";
import { TimespanRecord } from "./TimespanRecord";

export const ConstraintRecord = Record({
  id: null,
  constraintType: null,
  subject: null,
  subjectTarget: null,
  object: null,
  objectTarget: null,
  comparison: null,
  date: DateRecord(),
  offset: TimespanRecord(),
  partPrecision: null,
  partValue: null // string or null
});

const data = {
  objects: {
    offset: "TimespanRecord",
    date: "DateRecord"
  }
};
createFromJS.registerCallback("ConstraintRecord", createFromJS.createNestedCallback(ConstraintRecord, data));
